import {AppState} from "../store";

export const getDriverActivityDayPageFilter = (state: AppState) => state.driverActivityDayPage.filter
export const getDriverActivityDayPageState = (state: AppState) => state.driverActivityDayPage.state
export const getDriverActivityDayPageHiddenPersons = (state: AppState) => state.driverActivityDayPage.hiddenPersonIds
